import PropTypes from "prop-types";
import React from "react";

export default class WalletDescription extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {
        const showCredits = this.props.showCredits !== false

        return (
            <div className={"mt-2"}>
                {
                    (this.props.payable_categories.length > 0 || this.props.payable_items.length > 0) &&
                    <div>
                        {/*Categorie pagabili*/}
                        {this.props.payable_categories.map((c, i) => {
                            return <div className={"small"} key={i}>
                                {
                                    showCredits ?
                                        <span>- {c.max_payments_num} crediti su {c.initial_max_payments_num} per la categoria <b>{c.nome}</b></span>
                                        :
                                        <span>- Puoi spendere il saldo della gift card nella categoria <b>{c.nome}</b></span>
                                }
                            </div>
                        })}

                        {/*Items pagabili*/}
                        {this.props.payable_items.map((item, i) => {
                            return <div className={"small"} key={i}>
                                {
                                    showCredits ?
                                        <span>- {item.max_payments_num} crediti su {item.initial_max_payments_num} per l'elemento: <b>{item.nome}</b></span>
                                        :
                                        <span>- Puoi spendere il saldo della gift card per l'elemento <b>{item.nome}</b></span>
                                }
                            </div>
                        })}
                    </div>
                }
            </div>
        )
    }
}

WalletDescription.propTypes = {
    payable_categories: PropTypes.array,
    payable_items: PropTypes.array,
    showCredits: PropTypes.bool,
}
